// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"7ed4f00e","970":"f884ef7d"}[chunkId] + ".chunk.js";
};